<template>
  <div>
    <div class="table-responsive">
      <table class="table table-hover">
        <thead>
          <tr>
            <th>{{$t('name')}}</th>
            <th>{{$t('email')}}</th>
            <th>{{$t('role')}}</th>
            <th>{{$t('status')}}</th>
            <th>{{$t('hours_logged')}}</th>
            <th>{{$t('last_activity')}}</th>
            <th>{{$t('action')}}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="assignment in projectAssignments" :key="assignment.id">
            <td>{{ assignment.user ? assignment.user.name : '-' }}</td>
            <td>{{ assignment.user ? assignment.user.email : '-' }}</td>
            <td>
              <span class="badge bg-info">{{ $t(assignment.role) }}</span>
            </td>
            <td>
              <span class="badge bg-primary">{{ $t(assignment.status) }}</span>
            </td>
            <td>{{ assignment.hours_logged || 0 }}h</td>
            <td>{{ formatDate(assignment.last_activity) }}</td>
            <td>
              <button v-if="helper.checkAccess('edit_projects') > 0" @click="removeMember(assignment)" style="padding: 5px;margin: 0;font-size: 12px !important;" class="btn btn-primary btn-xs">
                <AppIcon name="bi-trash" class="bi bi-trash" style="font-size:12px" />
                {{$t('remove')}}
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <div v-if="!projectAssignments.length" class="text-center py-3">{{$t('no_team_members')}}</div>
    </div>
  </div>
</template>

<script>
import helper from '../../helper'

export default {
  name: 'TeamList',
  data() {
    return {
      helper
    }
  },
  props: {
    projectId: {
      type: String,
      required: true
    },
    assignments: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    projectAssignments() {
      // Filter to show only project-level assignments (no task_id)
      const projectLevelAssignments = this.assignments.filter(a => !a.task_id)
      
      // Remove duplicates based on user_id
      const uniqueAssignments = []
      const seenUserIds = new Set()
      
      for (const assignment of projectLevelAssignments) {
        if (!seenUserIds.has(assignment.user_id)) {
          seenUserIds.add(assignment.user_id)
          uniqueAssignments.push(assignment)
        }
      }
      
      return uniqueAssignments
    }
  },
  methods: {
    async removeMember(assignment) {
      if (helper.checkAccess('edit_projects') <= 0) return
      if (!confirm(this.$t('confirm_remove_member'))) return
      try {
        await helper.customDelete(`${process.env.VUE_APP_API}/projects/${this.projectId}/users/${assignment.user_id}`, { showToast: true })
        this.$emit('removed', assignment.user_id)
      } catch (error) {
        alert('Error removing member:', error)
      }
    },
    formatDate(date) {
      if (!date) return '-'
      return new Date(date).toLocaleString()
    }
  }
}
</script>
